var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "home_active",
    "data-name": "home active",
    transform: "translate(-341 -704)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3499",
    "data-name": "Rectangle 3499",
    width: 54,
    height: 54,
    transform: "translate(341 704)",
    fill: "#fd614d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Inactive",
    transform: "translate(346 709)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20",
    "data-name": "Rectangle 20",
    width: 44,
    height: 44,
    transform: "translate(0 0)",
    fill: "#151619"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40",
    "data-name": "Group 40",
    transform: "translate(-6418.55 -1604.528)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M6708.541,1605.233v12.412h.7v-13.116h-13.116v.7Z",
    transform: "translate(-246.695)",
    fill: "#ccfd34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M6419.254,1605.233h12.412v-.7H6418.55v13.116h.7Z",
    fill: "#ccfd34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M6708.541,1894.519h-12.412v.7h13.116v-13.116h-.7Z",
    transform: "translate(-246.695 -246.695)",
    fill: "#ccfd34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M6419.254,1894.519v-12.412h-.7v13.116h13.116v-.7Z",
    transform: "translate(0 -246.695)",
    fill: "#ccfd34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40-2",
    "data-name": "Group 40"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11-2",
    "data-name": "Path 11",
    d: "M6708.541,1605.233v12.412h.7v-13.116h-13.116v.7Z",
    transform: "translate(-6665.245 -1604.528)",
    fill: "#151619"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12-2",
    "data-name": "Path 12",
    d: "M6419.254,1605.233h12.412v-.7H6418.55v13.116h.7Z",
    transform: "translate(-6418.55 -1604.528)",
    fill: "#151619"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13-2",
    "data-name": "Path 13",
    d: "M6708.541,1894.519h-12.412v.7h13.116v-13.116h-.7Z",
    transform: "translate(-6665.245 -1851.224)",
    fill: "#151619"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14-2",
    "data-name": "Path 14",
    d: "M6419.254,1894.519v-12.412h-.7v13.116h13.116v-.7Z",
    transform: "translate(-6418.55 -1851.224)",
    fill: "#151619"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4550",
    "data-name": "Group 4550",
    transform: "translate(-292.887 -143.422)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_1",
    "data-name": "Union 1",
    d: "M-19802.645-17160.738l-.021-8.2-3.447.027,14.668-14.668,14.436,14.439-3.475.027v8.373Z",
    transform: "translate(20106.447 17337.578)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3543",
    "data-name": "Path 3543",
    d: "M22655.309,17338.471v-5.885h4.957v5.885",
    transform: "translate(-22342.9 -17161.625)",
    fill: "#151619"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/homeIcon.5cc573731a1e77381e3f17e1b1e02559.svg";
export { ForwardRef as ReactComponent };